import * as React from 'react';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { getIsPropertyChangedEvent, getObjectTypeIdFromFlowEventFilter, mapToRenderableDebugFilterBranch, mapToRenderableFilterBranch } from 'flow-doctor-lib/utils/eventFilterUtils';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import StyledFilterContainer from 'flow-doctor-lib/components/filters/StyledFilterContainer';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlowEventFilterRenderer = ({
  portalId,
  flowEventFilter,
  flowObjectTypeId,
  debugFilter,
  filterWidthType = 'EVENT_STRETCHED'
}) => {
  const objectTypeId = getObjectTypeIdFromFlowEventFilter(flowEventFilter);
  return /*#__PURE__*/_jsxs(StyledFilterContainer, {
    filterWidthType: "DEFAULT",
    children: [/*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(ObjectTypeLabel, {
        objectTypeId: objectTypeId,
        portalId: portalId
      })
    }), /*#__PURE__*/_jsx("br", {}), getIsInternal() && /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.eventFilters.objectTypeId",
        options: {
          objectTypeId
        }
      })
    }), flowEventFilter.eventFilter.filter && /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
      bordered: false,
      objectTypeId: getIsPropertyChangedEvent(objectTypeId) ? flowObjectTypeId : objectTypeId,
      filterBranch: mapToRenderableFilterBranch(objectTypeId, flowEventFilter.eventFilter.filter),
      debugOptions: debugFilter ? {
        filterBranch: debugFilter && mapToRenderableDebugFilterBranch(objectTypeId, debugFilter),
        displayMode: 'ALL'
      } : undefined,
      filterWidthType: filterWidthType
    })]
  });
};
export default FlowEventFilterRenderer;